








import Vue from 'vue'
import { ReportMenuTreeItem } from '@/model/reporting/ReportMenuTreeItem'
import { LOAD_REPORTS_LIST } from '@/store/action-types'
import { ReportFilterItem } from '@/types/service-response'

interface ComponentData {
  treeItemList: Array<ReportMenuTreeItem>
  active: Array<number>
  reportItem: Array<ReportFilterItem>
  reportLayout: string
  reportName: string
}

interface Child {
  reportId: number
  id: number
  reportName: string
  name: string
  filters: Array<ReportFilterItem>
}

export default Vue.extend({
  name: 'ReportingTree',

  props: {
    addressId:{
      type: Number,
      default: undefined
    }
  },

  data (): ComponentData {
    return {
      treeItemList: [],
      active: [],
      reportItem: [],
      reportLayout: '',
      reportName: ''
    }
  },

  watch: {
    selected: 'selected',

    addressId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.fetchData()
      }
    }
  },

  computed: {
    selected (): void {
      if (this.active.length && this.treeItemList) {
        this.treeItemList.forEach((item: ReportMenuTreeItem) => {
          const children = item.children.find((i: Child) => {
            return i.id === this.active[0]
          })
          if (children) {
            this.reportItem = []
            this.reportLayout = children.reportLayout
            this.reportName = children.reportName
            children.filters.forEach((item: ReportFilterItem) => {
              this.reportItem.push(item)
            })
          }
        })
        let payload: { reportItem: Array<ReportFilterItem>, reportLayout: string, reportName: string } = {
          reportItem: this.reportItem,
          reportLayout: this.reportLayout,
          reportName: this.reportName
        }
        this.$emit('selectedReport', payload)
      }
    }
  },

  methods: {
    async fetchData (): Promise<void> {
      this.$store.dispatch(LOAD_REPORTS_LIST, this.addressId ? 28 : 25).then((data: ReportMenuTreeItem[]) => {
        let index: number = 0
        this.treeItemList = data.map ((item: ReportMenuTreeItem) => {
          index++
          return {
            children: item.children,
            groupId: item.groupId,
            id: index,
            name: item.name,
            reportGroupName: item.reportGroupName,
          }
        })
      })
    }
  },

  async mounted () {
    this.$store.dispatch(LOAD_REPORTS_LIST, this.addressId ? 28 : 25).then((data: ReportMenuTreeItem[]) => {
      let index: number = 0
      this.treeItemList = data.map ((item: ReportMenuTreeItem) => {
        index++
        return {
          children: item.children,
          groupId: item.groupId,
          id: index,
          name: item.name,
          reportGroupName: item.reportGroupName,
        }
      })
    })
  }

})
